import React from 'react';
import { ButtonBase, Icon, Flex } from '@tonic-ui/react';

const NavigationButtons = ({
  pages,
  activePage,
  onClick,
}: {
  pages: number[];
  activePage: number;
  onClick: (pageId: number) => void;
}) => {
  const pageCount = pages.length;
  const canGoBack = activePage > 0;
  const canGoNext = activePage < pageCount - 1;
  return (
    <Flex width="100%" flexDirection="row-reverse" marginTop="20px" marginRight="20px">
      <ButtonBase
        disabled={!canGoNext}
        onClick={() => canGoNext && onClick(activePage + 1)}
        backgroundColor={!canGoNext ? 'red:30' : 'red:60'}
        padding="10px"
        borderRadius="50%"
        marginRight="8px"
      >
        <Icon icon="chevron-right" color="white:primary" />
      </ButtonBase>
      <ButtonBase
        disabled={!canGoBack}
        onClick={() => canGoBack && onClick(activePage - 1)}
        backgroundColor={!canGoBack ? 'red:30' : 'red:60'}
        padding="10px"
        borderRadius="50%"
        marginRight="8px"
      >
        <Icon icon="chevron-left" color="white:primary" />
      </ButtonBase>
    </Flex>
  );
};

export default NavigationButtons;
